import React, {useState, useEffect} from 'react'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'

import Api from 'utils/Api'
import useFlash from 'modules/useFlash'
import useUpdater from 'modules/useUpdater'
import { WrapForm, } from 'components/molecules/Wrap'

import Form from './parts/Form'

export default (props) => {
  const id = props.match.params.id
  const {handleApiError} = useFlash()
  const [loading, setLoading] = useState(true)
  const [label, setLabel] = useState()
  const [lastUpdatedAt, update] = useUpdater()

  useEffect(()=>{
    setLoading(true)

    const subject = Api.fetchAuth(`/labels/${id}`).then(r=>r.json())
    Promise.all([subject]).then(responses=>{
      setLabel(responses[0].data)
      setLoading(false)
    }).catch(error=>{
      // setLoading(false)
      handleApiError(error)
    })
  }, [lastUpdatedAt])

  const save = (body) => {
    console.log('body', body)
    setLoading(true)
    return Api.fetchAuth(`/labels/${id}`, {
      method: 'PUT',
      body: body
    }).then(r=>r.json()).then(response=>{
      update()
      // setLoading(false)
      // window.location.href = '/labels'
    }).catch((error)=>{
      setLoading(false)
      handleApiError(error)
    })
  }

  if (loading) return (<CircularProgress />)

  return (
    <WrapForm>
      <Typography variant="h6" gutterBottom>Edit Label</Typography>
      <Form {...{save, subject: label}} />
    </WrapForm>
  )
}
